import { render, staticRenderFns } from "./Leiloes.vue?vue&type=template&id=715854ee"
import script from "./Leiloes.vue?vue&type=script&lang=js"
export * from "./Leiloes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports